import { render } from "./Navbar.vue?vue&type=template&id=9a1edc74&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=9a1edc74&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9a1edc74"

export default script